const inventoryMenu = [
  {
    System: 'INV',
    isActive: true,
    menu: [
      { is_header: true, title: 'Inventories', isActive: true },
 

        {
        path: '/INV/HomePage',
        icon: 'fas fa-home',
        title: 'HomePage',
        isActive: true
      },

      { is_header: true, title: 'Settings', isActive: true },

      {
        path: '/INV/InventorySettings/Inventory',
        title: 'Inventories',
        icon: 'fas fa-warehouse',
        permission: 'INVViewInventoryList',
        isActive: true
      },
      {
        path: '/INV/InventorySettings/Categories',
        title: 'Categories',
        icon: 'fas fa-list',
        permission: 'INVViewCategoriesList',
        isActive: true
      },
      {
        path: '/INV/InventorySettings/MasterItems',
        title: 'Items',
        icon: 'fas fa-boxes',
        permission: 'INVViewMasterItemsList',
        isActive: true
      },

      {
        path: '/INV/InventorySettings/UnitsOfMeasure',
        title: 'UnitsOfMeasure',
        icon: 'fas fa-ruler',
        permission: 'INVViewUnitsOfMeasureList',
        isActive: true
      },
      {
        path: '/INV/InventorySettings/TransactionTypes',
        title: 'TransactionTypes',
        icon: 'fas fa-exchange-alt',
        permission: 'INVViewTransactionTypesList',
        isActive: true
      },
      {
        path: '/INV/InventorySettings/Brand',
        title: 'Brand',
        icon: 'fas fa-tag',
        permission: 'INVViewBrandsList',
        isActive: true
      },

      {
        path: '/INV/InventorySettings/Attributes',
        title: 'ItemAttributes',
        icon: 'fas fa-sliders-h',
        permission: 'INVViewAttributessList',
        isActive: true
      },

      { is_header: true, title: 'Operations', isActive: true },

      {
        path: '/INV/Transactions/All',
        title: 'الحركات المخزنية',
        icon: 'fas fa-dolly',
        permission: 'INVViewInvIssueList',
        isActive: false
      },
      {
        path: '/INV/Transactions/InvIssue',
        title: 'InvIssue',
        icon: 'fas fa-dolly',
        permission: 'INVViewInvIssueList',
        isActive: true
      },
      {
        path: '/INV/Transactions/InvReceive',
        title: 'InvReceive',
        icon: 'fas fa-inbox',
        permission: 'INVViewInvReceiveList',
        isActive: true
      },
      {
        path: '/INV/Transactions/InvMove',
        title: 'TransferOrder',
        icon: 'fas fa-exchange-alt',
        permission: 'INVViewInvMoveList',
        isActive: true
      },
      {
        path: '/INV/Transactions/UpdateCost',
        title: 'UpdateCost',
        icon: 'fas fa-dollar-sign',
        permission: 'INVViewUpdateCostList',
        isActive: true
      },
      {
        path: '/INV/Transactions/Allocate',
        title: 'Allocate',
        icon: 'fas fa-tasks',
        permission: 'INVViewAllocateList',
        isActive: true
      },
      {
        path: '/INV/Transactions/CreateAccountInventory',
        title: 'CreateAccountInventory',
        icon: 'fas fa-share-square',
        permission: 'INVViewCreateAccountInventoryList',
        isActive: true
      },
      {
        path: '/INV/Transactions/AccountingPeriod',
        title: 'AccountingPeriod',
        icon: 'fas fa-calendar-alt',
        permission: 'INVViewAccountingPeriodsList',
        isActive: true
      },

      // { is_header: true, title: 'InventoryCount', isActive: true },

      // {
      //   path: '/INV/InventoryCount',
      //   title: 'InventoryCount',
      //   icon: 'fas fa-boxes',
      //   permission: 'INVViewInventoryCountList',
      //   isActive: true
      // },
      // {
      //   path: '/qw',
      //   title: 'PhysicalInventory',
      //   icon: 'fas fa-warehouse',
      //   permission: 'INVViewPhysicalInventoryList',
      //   isActive: true
      // },
      // {
      //   path: '/we',
      //   title: 'InventoryResults',
      //   icon: 'fas fa-chart-bar',
      //   permission: 'INVViewInventoryResultsList',
      //   isActive: true
      // },
      { is_header: true, title: 'Reports', isActive: true },

      {
        path: '/INV/Reports',
        icon: 'fas fa-chart-bar',
        title: 'Reports',
        isActive: true
      },

      {
        path: '/INV/Dashboard',
        icon: 'bi bi-cpu',
        title: 'Dashboard',
        isActive: true
      }
    ]
  }
];

export default inventoryMenu;
